package dev.valvassori.minesweeper.helpers

import kotlin.js.Date

actual fun currentMillis(): Number = Date.now()
